
export const OPTIMIZE_ACTIVATION_EVENT = {
  sellerNameChangeMetroMakro: 'optimize.activate.seller-name-change',
};
